import angular from 'angular';
import PrintingSummaryApiService from './PrintingSummaryApiService';

export default angular.module('app.resources.printingSummary', [])
  .service('PrintingSummaryApiService', PrintingSummaryApiService)
  .name;
